/**
 * ? Get Email Id from User
 */

// Dependencies
import React, { Fragment, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// MUI icons
import { Email } from "@mui/icons-material";

// Assets
import ltelogo from "./../../assets/logov1.svg";

// Axios Component
import Axios from "../../axios/Axios";

// Redux Component
import { showSnackbar } from "../redux/features/appSlice";


function GetEmail() {
  // * Router Variable
  const navigate = useNavigate();

  // * Redux Variable
  const dispatch = useDispatch();

  // * State Variable
  const [emailId, setEmailId] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState({
    error: false,
    message: "",
  });

  // TODO : Validate Mail Value
  // function validateMail(mail) {
  //   if (mail.length > 0) {
  //     let pattern = new RegExp(
  //       /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  //     );
  //     let result = pattern.test(mail);
  //     return result;
  //   }
  // }

  // ? API Call : Post Method
  async function submitEmailId() {
    try {

      if (emailId) {
        setLoading(true);
        const data = {
          email_id: emailId.toLowerCase(),
        };

        const options = {
          method: "post",
          url: "/adminlogin/check/isemailexists",
          auth: true,
          data: data,
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data
        );
          // console.log(response);
        if (response.status === 200 && response.data.message) {
          setLoading(false);
          setEmailId("");
          setEmailError({
            error: false,
            message: "",
          })
          dispatch(
            showSnackbar({
              message:
                "Password reset link sent to your email address, Please check it !",
              severity: "success",
            })
          );
          // setInterval(() => {
          //   window.location.reload();
          // }, 5000);
        } else {
          setLoading(false);
          dispatch(
            showSnackbar({
              message: "Provided Email address is not registered !",
              severity: "error",
            })
          );
        }
      } else {
        setEmailError({
          error: true,
          message: "Enter valid email address.",
        });
      }
    } catch (error) {
      setLoading(false);
      dispatch(
        showSnackbar({
          message: "Error occurred! Please try again later.",
          severity: "error",
        })
      );
    }
  }

  return (
    <Fragment>
      {/* Navigation Bar */}
      <Navbar className="login-admin">
        <Navbar.Brand href="#">
          <Box onClick={() => navigate("/login")}>
            <div class="navbar-brand">
              <img className="ltelogo" src={ltelogo} alt="Logo" />
              <span className="login-admin-title">Lets Teach English</span>
            </div>
          </Box>
        </Navbar.Brand>
      </Navbar>

      <Box
        sx={{
          width: "600px",
          m: "220px auto",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          borderRadius: "10px",
          opacity: 1,
        }}
      >
        {/* Title */}
        <Box>
          <Typography variant="h6" component="div" gutterBottom>
            Forgot Password
          </Typography>
        </Box>

        {/* Input Field */}
        <Box>
          <Typography variant="p" component="div" sx={{ mb: "8px" }}>
            E-mail Id
          </Typography>
          <TextField
            type="email"
            name="email"
            variant="outlined"
            size="small"
            label="Email ID"
            placeholder=""
            sx={{ width: 500 }}
            InputProps={{
              autoComplete: "off",
              endAdornment: (
                <InputAdornment>
                  <IconButton>
                    <Email />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={emailId}
            onChange={(e) => {
              setEmailError({
                error: false,
                message: "",
              });
              setEmailId(e.target.value);
            }}
            error={emailError.error}
            helperText={emailError.error ? emailError.message : ""}
          />
        </Box>

        {/* Button */}
        <Box sx={{ mt: "16px", mb: "16px" }}>
          <LoadingButton
            loading={loading}
            type="submit"
            variant="contained"
            color="primary"
            sx={{ backgroundColor: "#1D3FAA", color: "#fff" }}
            onClick={submitEmailId}
          >
            continue
          </LoadingButton>
        </Box>
      </Box>
    </Fragment>
  );
}

export default GetEmail;
